
import { mapState, mapGetters, mapActions } from "vuex";
import EmptyCartIcon from "~/assets/images/emptyCartIcon.svg";
import MenuOrderItemUnavailableDialog from "../dialogs/menu-order-item-unavailable-dialog.vue";
import CartDeliveryLocation from "./cart-delivery-location.vue";
import CartItem from "./cart-item.vue";
import CartPaymentSummary from "./cart-payment-summary.vue";
import razorpay from "../../mixins/razorpay";
export default {
  mixins: [razorpay],
  components: {
    CartItem,
    CartPaymentSummary,
    CartDeliveryLocation,
    MenuOrderItemUnavailableDialog
  },
  data() {
    return {
      EmptyCartIcon,
      loading: false,
      orderInstructions: "",
      showItemUnavailableDialog: false
    };
  },
  async beforeMount() {
    try {
      await this.validateCart();
    } catch (error) {
      // this.$nuxt.$emit("show-error-toast", error);
    }
    this.orderInstructions = this.cart.customer_notes;
  },
  computed: {
    ...mapState("order", ["cart", "cartLoading", "cartSyncing"]),
    ...mapGetters("order", [
      "getUnavailableItems",
      "isHomeDelivery",
      "isIncompleteDeliveryAddressInCart"
    ])
  },
  methods: {
    ...mapActions("order", [
      "updateCart",
      "validateCart",
      "checkoutCart",
      "initiatePayment",
      "syncCart"
    ]),
    handleUpdateOrderInstructions() {
      this.updateCart({ customer_notes: this.orderInstructions });
    },
    async handleCheckout() {
      if (this.getUnavailableItems.length) {
        this.showItemUnavailableDialog = true;
        return;
      }
      try {
        this.loading = true;
        await this.addRazorpayScript();
        this.syncCart();
        await this.sleep(2000);
        const validateResponse = await this.validateCart();
        if (validateResponse.status === 200) {
          const { data } = await this.checkoutCart();
          const orderId = data.whatsapp_order_id;
          if (orderId) {
            const res = await this.initiatePayment({ orderId });
            const { razor_pay_key, razor_pay_order } = res?.data || {};
            if (razor_pay_key && razor_pay_order) {
              const options = {
                key: razor_pay_key,
                amount: Math.round(razor_pay_order.amount * 1000),
                currency: razor_pay_order.currency,
                name: "Foaps",
                description: "Payment for WhatsApp Order",
                image: "https://v2.foaps.co/v2/icon.svg",
                order_id: razor_pay_order.id,
                prefill: {
                  name: this.cart.customer?.name || "",
                  // email: this.user?.email || "email@foaps.co",
                  contact: this.cart.customer?.phone_number || "+919999999999"
                },
                notes: razor_pay_order.notes,
                theme: {
                  color: "#FF6B28"
                }
              };
              this.proceedRazorpayPayment(
                options,
                this.handleSendToBusiness,
                this.handlePaymentFailure
              );
            }
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;

          if (errors.length > 0) {
            this.showItemUnavailableDialog = true;
          } else {
            this.$nuxt.$emit("show-error-toast", error);
          }
        } else {
          this.$nuxt.$emit("show-error-toast", error);
        }
      }
      this.loading = false;
    },
    handleSendToBusiness() {
      this.$emit("show-back-to-whatsapp-dialog");
    },
    handlePaymentFailure(response) {
      if (typeof response === "string") response = JSON.parse(response);
      this.$nuxt.$emit(
        "show-error-toast",
        response?.error?.description || response
      );
    }
  }
};
